import { Instagram, MessageCircle } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

export const FloatingContact = () => {
  const { settings } = useSettings();

  // Clean WhatsApp / Instagram links — no pre-filled text, no contextual messages.
  const wa = settings?.whatsapp_url || '';
  const ig = settings?.instagram_url || '';

  if (!wa && !ig) return null;

  return (
    <div data-testid="floating-contact" className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3">
      {ig && (
        <a
          href={ig}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Open Instagram"
          data-testid="floating-instagram"
          className="group h-12 w-12 inline-flex items-center justify-center rounded-full text-white shadow-lg shadow-black/40 hover:scale-110 transition-transform"
          style={{ background: 'linear-gradient(135deg, #833AB4 0%, #FD1D1D 50%, #FCB045 100%)' }}
        >
          <Instagram className="h-5 w-5" />
        </a>
      )}
      {wa && (
        <a
          href={wa}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Open WhatsApp"
          data-testid="floating-whatsapp"
          className="group h-14 w-14 inline-flex items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/30 hover:scale-110 transition-transform relative"
        >
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" aria-hidden="true" />
          <MessageCircle className="h-6 w-6 relative" />
        </a>
      )}
    </div>
  );
};
